import * as L from "lucide-react";

const MAP = {
  heart: L.Heart, "heart-outline": L.Heart, star: L.Star, sunny: L.Sun, moon: L.Moon, leaf: L.Leaf,
  water: L.Droplets, fitness: L.Dumbbell, bicycle: L.Bike, walk: L.Footprints, bed: L.Bed, cafe: L.Coffee,
  restaurant: L.Utensils, book: L.BookOpen, "musical-notes": L.Music, brush: L.Brush,
  "game-controller": L.Gamepad2, people: L.Users, paw: L.PawPrint, flower: L.Flower2, earth: L.Globe,
  sparkles: L.Sparkles, flash: L.Zap, bulb: L.Lightbulb, rocket: L.Rocket, trophy: L.Trophy,
  ribbon: L.Award, medkit: L.Stethoscope, bandage: L.Bandage, eye: L.Eye, "hand-left": L.Hand,
  "checkmark-circle": L.CheckCircle2, medical: L.Cross, mic: L.Mic, "shield-checkmark": L.ShieldCheck,
  calendar: L.Calendar, infinite: L.Infinity, person: L.User, "chatbubble-ellipses": L.MessageCircle,
  "analytics-outline": L.BarChart3, "shield-outline": L.Shield, "sparkles-outline": L.Sparkles,
  "chatbubbles-outline": L.MessagesSquare, "leaf-outline": L.Leaf, "lock-closed-outline": L.Lock,
  "calendar-outline": L.Calendar, "trophy-outline": L.Trophy, "mic-outline": L.Mic,
  "book-outline": L.BookOpen, "pulse-outline": L.Activity, "people-outline": L.Users,
};

export const Icon = ({ name, size = 20, className, style }) => {
  const C = MAP[name] || MAP[name?.replace("-outline", "")] || L.Sparkles;
  return <C size={size} className={className} style={style} />;
};
